module.exports = __webpack_public_path__ + "img/16.b9962b3a.png";